var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsersCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4166 20.9999L21.75 23.3332L26.4166 18.6666M18.8333 3.83911C20.5435 4.5314 21.75 6.20809 21.75 8.16656C21.75 10.125 20.5435 11.8017 18.8333 12.494",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 17.5H10.0833C7.90892 17.5 6.82172 17.5 5.96412 17.8552C4.82066 18.3289 3.91218 19.2373 3.43854 20.3808C3.08331 21.2384 3.08331 22.3256 3.08331 24.5M16.5 8.16667C16.5 10.744 14.4106 12.8333 11.8333 12.8333C9.25598 12.8333 7.16665 10.744 7.16665 8.16667C7.16665 5.58934 9.25598 3.5 11.8333 3.5C14.4106 3.5 16.5 5.58934 16.5 8.16667Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsersCheck);
export default __webpack_public_path__ + "static/media/IconUsersCheck.ed5e9c5486b8aa573e5293261175f64c.svg";
export { ForwardRef as ReactComponent };